import { withFormsy, propTypes } from 'formsy-react';
import domainModel from 'domain-model';
import React, { PureComponent } from 'react';
import Async from 'react-select/async';
import { components } from 'react-select';
import { Row, Col } from 'reactstrap';
import qs from 'qs';
import axios from 'axios';
import PropTypes from 'prop-types';
import _ from 'lodash';
// @ts-expect-error these exist in front end projects
// eslint-disable-next-line import/no-unresolved
import ArticleBadges from 'components/article/ArticleBadges';
import { getAxiosInstance } from '../../utils/appWrapper';
import ArticleImage from '../article/ArticleImage';

let cancelTokenSource = null;

/* eslint-disable */
const MenuList = props => {
  return (
    <components.MenuList {...props}>
      <table class="table w-100 mt-n1">
        <caption>
          Lista med sökresultat,{' '}
          {props.options.length === 0
            ? 'sökningen gav inget resultat'
            : 'skriv för att söka efter fler.'}
        </caption>
        <thead class="table-light">
          <tr>
            <th className="text-nowrap text-center w-100 py-1">
              Artikelnummer
            </th>
            <th className="text-nowrap text-center w-100 py-1">Artikelnamn</th>
            <th className="text-nowrap text-center w-100 py-1">
              Antal i lager (st)
            </th>
            <th className="text-nowrap text-center w-100 py-1">
              Försäljningspris per styck på webben (exkl. pant)
            </th>
            <th className="text-nowrap text-center w-100 py-1">
              Kategori / Typ / Stil
            </th>
          </tr>
        </thead>
        <tbody>{props.children}</tbody>
      </table>
    </components.MenuList>
  );
};

const Option = props => {
  return (
    <tr
      id={props.innerProps.id}
      ref={props.innerRef}
      className={
        (props.isSelected ? 'table-active' : '') +
        (props.isFocused ? ' bg-light' : '') +
        ' select-option'
      }
      onClick={() => {
        props.selectOption(props.data);
      }}
    >
      <td className="text-nowrap py-1">{props.data.articleNumber}</td>
      <td className="text-nowrap py-1">{props.data.shortName}</td>
      <td className="text-nowrap py-1">{props.data.quantityInStock}</td>
      <td className="text-nowrap py-1">{props.data.salesPrice}</td>
      <td className="text-nowrap py-1">{props.data.productCategory}</td>
    </tr>
  );
};

function withFormsyValidations(
  WrappedComponent,
  validations,
  validationErrors,
) {
  const FormsyfiedComponent = withFormsy(WrappedComponent);

  return props => (
    <FormsyfiedComponent
      validations={validations ? validations(props) : undefined}
      validationErrors={validationErrors}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      value={_.get(props, 'value.id')}
      article={props.value}
    />
  );
}

const ValueContainer = ({ children, selectProps, ...restOfProps }) => {
  const pricedArticle = selectProps.value || {};
  const {
    disposableQuantity = 0,
    quantityInStock = 0,
    myOrderFullfillmentCenter = {},
    colliSize = 1,
  } = pricedArticle;

  return (
    <>
      <Row style={{ width: '95%' }} className="justify-content-between">
        <Col sm={3} xs={12} className="align-self-center text-center">
          <ArticleImage
            resX={100}
            resY={100}
            article={pricedArticle}
            alt="product image"
          />
        </Col>
        <Col sm={9} xs={12} className="ps-sm-4 ms-sm-0 ms-2">
          <Row>
            <Col className="mt-sm-2">
              <h5>
                <components.ValueContainer
                  {...{ ...restOfProps, selectProps }}
                  className="ps-0"
                >
                  {children}
                </components.ValueContainer>
              </h5>
            </Col>
          </Row>
          {!_.isEmpty(pricedArticle) && (
            <>
              <Row className="mt-n2 mb-1">
                <Col xs="auto" className="text-larger text-wrap">
                  <ArticleBadges entity={pricedArticle} />
                </Col>
              </Row>
              {_.get(pricedArticle, 'onCopack') && (
                <>
                  <Row className="mt-n1 justify-content-between">
                    <Col xs="auto">
                      I lager - {myOrderFullfillmentCenter.name}
                    </Col>
                    <Col xs="auto">
                      {domainModel.article.getRoundedQuantityInParcels(
                        pricedArticle,
                        quantityInStock,
                      )}{' '}
                      {colliSize !== 1 && <>({quantityInStock} st)</>}
                    </Col>
                  </Row>
                  <Row className="justify-content-between">
                    <Col xs="auto">Disponibelt</Col>
                    <Col xs="auto">
                      {domainModel.article.getRoundedQuantityInParcels(
                        pricedArticle,
                        disposableQuantity,
                      )}{' '}
                      {colliSize !== 1 && <> ({disposableQuantity} st) </>}
                    </Col>
                  </Row>
                </>
              )}
            </>
          )}
        </Col>
      </Row>
    </>
  );
};

/* eslint-enable */
const fetchStockInfoOnOfc = async (articles, orderFullfillmentCenter) => {
  const searchStr = qs.stringify({
    articles: articles.map(article => ({ id: article.id })),
    orderFullfillmentCenter: { id: _.get(orderFullfillmentCenter, 'id') },
  });
  const requestUrl = `/reportEngine/reports/article/stockInfoOnOfc?${searchStr}`;
  const response = await getAxiosInstance().get(requestUrl);
  const stockInfoOnOfcReport = response.data;
  return stockInfoOnOfcReport;
};

class ArticleSelect extends PureComponent {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      isDisabled: PropTypes.bool,
      onChange: PropTypes.func,
      customerSubUnit: PropTypes.object,
      supplierCustomer: PropTypes.object,
      immutableQuery: PropTypes.object,
      orderFullfillmentCenter: PropTypes.object,
      ...propTypes,
    };
  }

  static get defaultProps() {
    return {
      isDisabled: false,
      customerSubUnit: undefined,
      supplierCustomer: undefined,
      orderFullfillmentCenter: undefined,
      immutableQuery: {},
      onChange: () => {},
    };
  }

  constructor(props) {
    super(props);
    this.search = this.search.bind(this);
    this.selectHandler = this.selectHandler.bind(this);
    this.debouncedSearch = _.debounce(this.search, 250);
  }

  search(inputValue, callback) {
    const {
      customerSubUnit,
      immutableQuery,
      supplierCustomer,
      orderFullfillmentCenter,
    } = this.props;
    const query = {
      active: true,
      ...domainModel.article.createSearchStringQuery(inputValue),
      ...immutableQuery,
    };

    const queryStr = qs.stringify({
      query,
      customerSubUnit: _.get(customerSubUnit, 'id'),
      supplierCustomer: _.get(supplierCustomer, 'id'),
      cacheBuster: new Date().getTime(),
    });
    const requestUrl = `/pricedArticles/?${queryStr}`;
    if (cancelTokenSource) {
      cancelTokenSource.cancel();
    }
    /*
    https://stackoverflow.com/questions/50837291/how-to-use-debounce-on-async-function
    https://stackoverflow.com/questions/55073545/react-select-debounced-async-call-not-displaying-suggestions
    debounce and React aysnc select are not very happy using async await
    that's why we have to use the promise way of doing things
    WARNING
    */
    cancelTokenSource = axios.CancelToken.source();
    getAxiosInstance()
      .get(`${requestUrl}`, {
        cancelToken: cancelTokenSource.token,
      })
      .then(pricedArticleListReponse => {
        cancelTokenSource = null;
        if (_.isEmpty(pricedArticleListReponse.data.rows)) {
          callback([]);
        } else if (!this.props.orderFullfillmentCenter) {
          callback(pricedArticleListReponse.data.rows);
        } else {
          fetchStockInfoOnOfc(
            pricedArticleListReponse.data.rows,
            orderFullfillmentCenter,
          )
            .then(stockInOfcReport => {
              const decoratedResult = pricedArticleListReponse.data.rows.map(
                article => {
                  const stockInfo = stockInOfcReport.rows.find(
                    x => x.article.id === article.id,
                  );
                  if (!stockInfo) {
                    return {
                      ...article,
                      quantityInStock: 0,
                      disposableQuantity: 0,
                    };
                  }
                  return {
                    ...article,
                    quantityInStock: stockInfo.quantityInStock,
                    disposableQuantity:
                      stockInfo.quantityInStock - stockInfo.reservedQuantity,
                  };
                },
              );
              callback(decoratedResult);
            })
            .catch(error => {
              // eslint-disable-next-line no-console
              console.log('error fetching stock info ofc', error);
            });
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log('error fetching priced articles', error);
      });
  }

  selectHandler(selectedArticle) {
    const { setValue } = this.props;
    const { onChange, name } = this.props;

    setValue(selectedArticle.id);
    onChange(name, selectedArticle);
  }

  render() {
    const { name, article, isDisabled, isValid } = this.props;

    return (
      <Async
        id={_.uniqueId('article-select')}
        cacheOptions
        instanceId={`select-${name}`}
        noOptionsMessage={() => ''}
        openMenuOnClick={false}
        className={!isValid ? 'border border-danger' : ''}
        name={name}
        value={article}
        components={{ ValueContainer, MenuList, Option }}
        isDisabled={isDisabled}
        loadOptions={this.debouncedSearch}
        // loadOptions={str => debounceInstance(str, this.search)}
        placeholder="Sök ..."
        getOptionValue={option => option.id}
        getOptionLabel={option =>
          [option.articleNumber, option.name].join(' - ')
        }
        onChange={this.selectHandler}
        styles={styles => ({
          // Fixes the overlapping problem of the component
          ...styles,
          menu: provided => ({
            ...provided,
            zIndex: 9999,
            position: 'relative',
          }),
        })}
      />
    );
  }
}

export default withFormsyValidations(ArticleSelect, props => ({
  requiredValidation(values, value) {
    if (props.required) {
      return !!value;
    }
    return true;
  },
}));
